import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-close\">\n    <path fill=\"currentColor\" d=\"M7 7.738L1.27 13.4a.527.527 0 0 1-.895-.367c0-.138.056-.27.154-.367l5.73-5.66-5.73-5.661a.514.514 0 0 1 0-.733.529.529 0 0 1 .742 0l5.73 5.66 5.726-5.66a.529.529 0 0 1 .742 0 .514.514 0 0 1 0 .733L7.74 7.005l5.73 5.66a.514.514 0 0 1 0 .735.527.527 0 0 1-.743 0L7 7.738z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol